import StyledContainer from "style/styledContainer"
import styled from "styled-components"


import outBgImg from 'assets/images/out_bg.png'
import SwitchBtnCom from "components/SwitchBtnCom"
import AssetsSelectCom from "components/AssetsSelectCom"
import PayNumberCom from "components/PayNumberCom"
import FunListCom from "components/FunListCom"
import ReceiveCom from "components/ReceiveCom"
import TransferInfoCom from "components/TransferInfoCom"
import ReceiveAddressCom from "components/ReceiveAddressCom"
import MainBtnCom from "components/MainBtnCom"
import { useAppSelector } from "hooks/redux/hooks"
import useDefData from "hooks/useDefData"
import LoadingWin from "components/LoadingWin"

const HomePage = () => {  
  useDefData()
  const {fromChain, toChain, fromToken, toToken} = useAppSelector((state) => state.coreInfo)
  const { loading } = useAppSelector((state) => state.app)

  return <HomeWrap>
    <EmptyColumn></EmptyColumn>
    <InputWrap>
      <StyledContainer $height="30px"></StyledContainer>
      <SwitchBtnCom></SwitchBtnCom>
      <StyledContainer $height="60px"></StyledContainer>
      {/* from 资产 */}
      <AssetsSelectCom label="From" direction="from" chainDetail={fromChain} tokenDetail={fromToken}></AssetsSelectCom>
      <StyledContainer $height="4px"></StyledContainer>
      {/* to 资产 */}
      <AssetsSelectCom label="Into" direction="to" chainDetail={toChain} tokenDetail={toToken}></AssetsSelectCom>
      {/* 支付数量 */}
      <StyledContainer $height="40px"></StyledContainer>
      <PayNumberCom></PayNumberCom>
      {/* 功能列表 */}
      <StyledContainer $height="40px"></StyledContainer>
      <FunListCom></FunListCom>
    </InputWrap>
    <StyledContainer $width="24px"></StyledContainer>
    <OutWrap>
      {/* 接收的金额 */}
      <ReceiveCom></ReceiveCom>
      <StyledContainer $height="30px"></StyledContainer>
      {/* 交易详情 */}
      <TransferInfoCom></TransferInfoCom>
      <StyledContainer $height="30px"></StyledContainer>
      {/* 接收地址 */}
      <ReceiveAddressCom></ReceiveAddressCom>
      <StyledContainer $height="50px"></StyledContainer>
      <MainBtnCom></MainBtnCom>
      {/* 测试代码 */}
      {/* <button onClick={() => setOpenSlippage(true)}>test</button> */}

      <LoadingWin loading={loading}></LoadingWin>
    </OutWrap>
  </HomeWrap>
}

const EmptyColumn = styled(StyledContainer)`
  flex: 1;

  @media screen and (min-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1440px) and (max-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1024px) and (max-width: 1440px) {
    flex: 1;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    flex: none;
    width: 24px;    
  }
  @media screen and (max-width: 768px) {
    flex: none;
    width: 24px;    
  }
`

const InputWrap = styled(StyledContainer)`
  flex: 4;
`

const OutWrap = styled(StyledContainer)`
  flex: 5;
  background-color: ${({theme}) => theme.basicWhite};
  background-image: url(${outBgImg});
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
  box-sizing: border-box;
  padding: 125px 30px 0;

  position: relative;

`

const HomeWrap = styled(StyledContainer)`
  display: flex;
  min-height: 100vh;
  flex: 1;

  @media screen and (max-width: 768px) {
    flex-direction: column !important;
  }
`


export default HomePage